// IE doesn't support the Spotify Web Player

export function embeddedAudio() {
    function isIE() {
        return window.navigator.userAgent.match(/(MSIE|Trident)/);
    }

    if (isIE()) {
        let spotifyBlocks = Array.prototype.slice.call(document.querySelectorAll('.adage-audio-spotify-js'));

        // Removing the embed keyword from the iframe src attribute will
        // allow IE to display the playlist and a helpful message to users

        spotifyBlocks.forEach(spotifyBlock => {
            let iframe = spotifyBlock.querySelector('iframe') as HTMLElement;
            let iframeSrc = iframe.getAttribute('src');
            let ieIframeSrc = iframeSrc.replace('/embed', '');

            iframe.setAttribute('src', ieIframeSrc);
        })
    }
}